export default "/images/6724c3994da73288f2e10d2c374b9efd.avif";